// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ALBUM_DESCRIPTION_SHOW_MORE = "Zobraz v\u00edce";
export const LIKE_BUTTON_LABEL = "L\u00edb\u00ed se mi";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku";
